import { render } from "./CategoryElevenFileUploadDialog.vue?vue&type=template&id=3d6c4c80&scoped=true"
import script from "./CategoryElevenFileUploadDialog.vue?vue&type=script&lang=ts"
export * from "./CategoryElevenFileUploadDialog.vue?vue&type=script&lang=ts"

import "./CategoryElevenFileUploadDialog.vue?vue&type=style&index=0&id=3d6c4c80&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d6c4c80"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog});
